import * as Flashes from 'client/features/session/contents/flashes'
import { fork, put } from 'redux-saga/effects'
import { initialize } from 'redux-form'
import { IsAuthRequest, 
    LoginRequest, LogoutRequest, 
    MagicLoginRequest, CurrentUserRequest, 
    ResetPasswordRequest, UpdatePasswordRequest, 
    SetPasswordRequest
} from 'client/features/session/actions'
import { flash } from 'client/features/flashes/actions'
import RequestSagas from 'client/core/RequestSagas'
import URLS from 'constant/URLS'

/*isAuth: check active session.*/
const AuthSagas = new RequestSagas(IsAuthRequest.get, { method: 'GET', endpoint: URLS.session.isAuth })
export function* isomorphicAuth(req) {
    if (req.currentUser) yield put(IsAuthRequest.get.actions.success({ user: req.currentUser }))
    else yield put(IsAuthRequest.get.actions.failure({ error: 'session_expired_or_nonexistent', code: 401, method: 'isomorphic' }))
}

/*Login*/
const LoginSagas = new RequestSagas(LoginRequest.post, { method: 'POST', endpoint: URLS.session.login })
LoginSagas.success = function* () {
    yield put(initialize('login', {}))
    //yield put(flash({ content: Flashes.loginSuccess() }))
}
LoginSagas.failure = function* (action) {
    yield put(flash({ content: Flashes.loginFailure(action.payload.error) }))
}

/*Logout*/
const LogoutSagas = new RequestSagas(LogoutRequest.get, { method: 'GET', endpoint: URLS.session.logout })
LogoutSagas.success = function* () {
    yield put(flash({ content: Flashes.logoutSuccess() }))
    window.location = '/login'
}

/*Magic Login*/
const MagicLoginSagas = new RequestSagas(MagicLoginRequest.post, { method: 'POST', endpoint: URLS.session.magicLogin })
MagicLoginSagas.success = function* () {
    yield put(flash({ content: Flashes.magicLoginSuccess() }))
}

/*Update current user*/
const UpdateCurrentUserSagas = new RequestSagas(CurrentUserRequest.put, { method: 'PUT', endpoint: URLS.session.updateCurrentUser })
UpdateCurrentUserSagas.success = function* (action) {
    yield put(flash({ content: Flashes.updateCurrentUserSuccess(action.payload.user) }))
}

/*Resetpassword */
const ResetPassword = new RequestSagas(ResetPasswordRequest.post, { method: 'POST', endpoint: URLS.session.resetPassword })
ResetPassword.success = function* () {
    
}

/*Setpassword */
const SetPassword = new RequestSagas(SetPasswordRequest.post, { method: 'POST', endpoint: URLS.session.setPassword })
SetPassword.success = function* () {
    
}

const UpdatePassword = new RequestSagas(UpdatePasswordRequest.post, { method: 'POST', endpoint: URLS.session.updatePassword })
UpdatePassword.success = function* () {
    window.location = '/'
}

/*Export watchers sagas*/
const sagas = [
    fork(AuthSagas.saga),
    fork(MagicLoginSagas.saga),
    fork(LoginSagas.saga),
    fork(LogoutSagas.saga),
    fork(UpdateCurrentUserSagas.saga),
    fork(ResetPassword.saga),
    fork(UpdatePassword.saga),
    fork(SetPassword.saga)
]


export default sagas



// WEBPACK FOOTER //
// ./src/client/features/session/sagas.js